import { RoutesInvoker } from "../../routesInvoker";
import * as WebRoutes from "@travellocal/utils/webRoutes";

export interface INavMenuLink {
  id?: number;
  text: string;
  href: string;
}
export interface IMainNavMenuLink extends INavMenuLink {
  submenu?: INavMenuLink[];
}

// ! HREF values need to be unique
export const navLinks = (loggedIn: boolean): IMainNavMenuLink[] => ([
  {
    text: "Home",
    href: WebRoutes.index(),
  },
  {
    text: "Destinations",
    href: WebRoutes.destinations(),
  },
  {
    text: "Inspiration",
    href: WebRoutes.inspiration(),
  },
  {
    text: "About Us",
    href: "#",
    submenu: [
      {
        text: "Overview",
        href: WebRoutes.aboutHome(),
      },
      {
        text: "Meet The Team",
        href: WebRoutes.aboutMeetTheTeam(),
      },
    ],
  },
  ...(loggedIn ? [{
    text: "My Trips",
    href: RoutesInvoker.customerIndex,
  }] : []),
]);
